<template>
  <fragment>
    <div class="cd-rate-calculator">
      <rate-calculator :zipcode="zipcode" :longitude="longitude" :latitude="latitude" :disclosure="disclosure" :disclaimer="disclaimer"></rate-calculator>
    </div>
  </fragment>
</template>

<script>
import { mapActions } from "vuex";
import CDRateCalculator from "./components/cdRateCalculator.vue";
import Vue from "vue";
import VueMq from "vue-mq";
  
// these are max widths of breakpoints
Vue.use(VueMq, {
  breakpoints: {
    mobile: 767,
    tablet: 991,
    desktop: Infinity
  }
});

export default {
  data() { 
    return {
      zipcode: this.locZip,
      latitude: this.locLat,
      longitude: this.locLong,
      disclaimer: this.openAccountDisclaimer,
      disclosure: this.disclosureText
    }
  },
  mounted() {
      // this is an old comment - need to check for data here so we can remove the timeout
  },
  components: {
    "rate-calculator": CDRateCalculator
  },
  methods: {
    ...mapActions([
    ]),
    renderCards() {

    },
  },
  props: {
    locLong: String,
    locLat: String,
    locZip: String,
    openAccountDisclaimer: String,
    disclosureText: String
  }
};
</script>
